
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Andheritopunecab() {



    const cardData =
    {
        keyword: ' Andheri to Pune Cab ',
        heading: 'Skyline Cabs:  Andheri to Pune Cab',
        headingDescription: 'Skyline Cabs provides reliable and comfortable Andheri to Pune Cab services for a smooth intercity journey. Whether you are traveling for work, visiting family, or heading to Pune Airport, our professional drivers and clean, well-maintained vehicles ensure a safe and timely ride. With door-to-door pickup in Andheri, 24/7 availability, and competitive fares, Skyline Cabs makes your travel experience hassle-free. Book your Andheri to Pune cab today and enjoy a comfortable and convenient trip.',

        top: 'Top Places to Visit in Pune with Skyline Cabs',

"topPlaces": [
    {
        "title": "Sinhagad Fort",
        "description": "Located around 35 km from Pune, Sinhagad Fort is perched atop a hill offering panoramic views of the surrounding valleys. The fort has a rich history, particularly associated with the Battle of Sinhagad in 1670 led by Tanaji Malusare. A popular trekking destination, it also features bastions, gates, and memorials. Visitors can relish local snacks like kanda bhaji and curd at small eateries on the fort."
    },
    {
        "title": "Shaniwar Wada",
        "description": "A historical fortification in the heart of Pune, Shaniwar Wada was built in 1732 as the seat of the Peshwas of the Maratha Empire. Known for its majestic architecture and fascinating history, the fort complex includes lush gardens, fountains, and the grand Delhi Gate. It is also surrounded by legends and ghost stories, making it a captivating destination for history buffs and curious travelers alike."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a monument of national importance. It served as a prison for Mahatma Gandhi, his wife Kasturba Gandhi, and other prominent leaders during the Quit India Movement. The palace showcases Italian arches and sprawling lawns, and it now houses a museum with Gandhi memorabilia, photographs, and his personal belongings, making it a must-visit for those interested in India's freedom struggle."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, the Dagdusheth Halwai Ganpati Temple is a spiritual hub in Pune. The temple is renowned for its beautiful idol of Lord Ganesha adorned with gold and ornaments. Thousands of devotees visit the temple daily, especially during the Ganesh Chaturthi festival, making it a vibrant and culturally rich experience."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "Dedicated to the memory of Dr. Dinkar G. Kelkar's son, this museum houses over 20,000 artifacts including musical instruments, sculptures, paintings, and everyday objects from across India. The collection provides a deep insight into India's cultural heritage, making it a treasure trove for art lovers and history enthusiasts."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, the Osho International Meditation Resort is a serene and luxurious retreat offering meditation programs, workshops, and wellness sessions. Surrounded by lush greenery and modern amenities, the ashram attracts spiritual seekers and tourists from around the world looking to rejuvenate mind and body."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "This 8th-century rock-cut temple, carved from a single basalt rock, is dedicated to Lord Shiva. Situated in the bustling Jangli Maharaj Road area, the Pataleshwar Cave Temple is a peaceful retreat that showcases ancient Indian rock-cut architecture. The temple’s main sanctum, Nandi mandapa, and intricate carvings draw both spiritual seekers and architecture lovers."
    },
    {
        "title": "Pashan Lake",
        "description": "A beautiful artificial lake located on the outskirts of Pune, Pashan Lake is a haven for bird watchers and nature lovers. Surrounded by hills and walking trails, it’s an ideal spot for a morning walk, photography, or simply relaxing in nature’s lap. The lake is particularly popular during the migratory bird season."
    },
    {
        "title": "Okayama Friendship Garden (Pune-Okayama Garden)",
        "description": "Inspired by Japan's Koraku-en Garden, this is one of the largest Japanese gardens outside of Japan. Spread over 10 acres, it features picturesque landscapes, flowing streams, and manicured lawns. Also known as Pu La Deshpande Garden, it's a peaceful place to unwind and experience a blend of Indian and Japanese gardening aesthetics."
    },
    {
        "title": "Lal Mahal",
        "description": "Lal Mahal holds a special place in Maratha history as the childhood home of Chhatrapati Shivaji Maharaj. Rebuilt in the 20th century, it contains exhibits and paintings that depict important events from Shivaji’s life. Located near Shaniwar Wada, it offers a glimpse into the Maratha legacy and the early years of one of India’s greatest warriors."
    }
],

"services": [
    {
      "name": "Andheri to Pune Taxi",
      "description": "Skyline Cabs offers reliable Andheri to Pune taxi services with a fleet of clean, air-conditioned vehicles driven by trained professionals. Enjoy smooth, on-time travel with flexible one-way and return options ideal for work, personal, or weekend travel."
    },
    {
      "name": "Andheri to Pune Round Trip Cab",
      "description": "Book your round trip cab from Andheri to Pune with Skyline Cabs and save more. Whether it's a day trip or a weekend getaway, our round trip options ensure convenience, comfort, and economical pricing with top-notch vehicle options."
    },
    {
      "name": "Andheri to Pune Innova Crysta",
      "description": "Travel with family or a group from Andheri to Pune in the luxurious Innova Crysta. Spacious seating, smooth suspension, and AC comfort make it the ideal ride for long-distance travel with Skyline Cabs."
    },
    {
      "name": "Taxi from Mumbai Andheri to Pune",
      "description": "Get a comfortable taxi from Mumbai Andheri to Pune with Skyline Cabs. Our well-maintained vehicles, experienced drivers, and GPS-enabled rides ensure timely pickups and drop-offs across any location in Pune."
    },
    {
      "name": "Andheri to Pune Ertiga Taxi Fare",
      "description": "Skyline Cabs provides budget-friendly Ertiga cabs from Andheri to Pune. Ideal for families and small groups, our fares include fuel, tolls, and driver charges with no hidden costs—just a smooth ride ahead."
    },
    {
      "name": "Andheri to Hinjewadi Cab Fare",
      "description": "Travel directly from Andheri to Pune's IT hub, Hinjewadi, with Skyline Cabs. Enjoy transparent fares, professional service, and comfort with sedan and SUV options perfect for business travelers."
    },
    {
      "name": "Andheri Airport to Pune Taxi Fare",
      "description": "Skyline Cabs offers convenient airport pickups from Andheri to Pune with transparent taxi fares. Ideal for domestic travelers and airport transfers with real-time tracking and on-time service."
    },
    {
      "name": "Mumbai Airport to Baner Cab Fare",
      "description": "Need a cab from Mumbai Airport to Baner, Pune? Book Skyline Cabs for a fixed, competitive fare and seamless intercity ride with air-conditioned cabs and professional chauffeurs."
    },
    {
      "name": "One Way Round Trip Cab from Mumbai",
      "description": "Skyline Cabs offers flexible one-way and round trip cab bookings from Mumbai to Pune and other cities. Choose from budget sedans to premium SUVs with 24/7 support and assured comfort."
    },
    {
      "name": "Juhu to Pune Cab Service",
      "description": "Travel from Juhu to Pune effortlessly with Skyline Cabs. We offer timely pickups, courteous drivers, and clean, sanitized vehicles suitable for business and leisure travel alike."
    },
    {
      "name": "Cab Service in Juhu Mumbai",
      "description": "Skyline Cabs is a trusted name for cab service in Juhu, Mumbai. From local rides to long-distance trips like Pune, we offer reliable cars, skilled drivers, and competitive rates around the clock."
    },
    {
      "name": "Juhu to Pune One Way Cab Fare",
      "description": "Book a cost-effective one-way cab from Juhu to Pune with Skyline Cabs. Our fare structure includes all essentials like tolls and fuel with no hidden charges, perfect for solo or group travel."
    },
    {
      "name": "Sakinaka to Pune Cab Service",
      "description": "Skyline Cabs offers direct cabs from Sakinaka to Pune with multiple vehicle choices, trained drivers, and punctual service for your comfort and peace of mind."
    },
    {
      "name": "Marol to Pune Cab",
      "description": "Need to travel from Marol to Pune? Skyline Cabs ensures a comfortable intercity ride with competitive pricing, clean vehicles, and driver support throughout the trip."
    },
    {
      "name": "Andheri to Pune Cab",
      "description": "Skyline Cabs provides reliable intercity cab service from Andheri to Pune with various vehicle choices including sedans, Ertiga, and Innova Crysta. Travel in style and safety with us."
    },
    {
      "name": "Pune to Andheri Cab",
      "description": "Get back to Andheri from Pune with our one-way cab services. Skyline Cabs ensures smooth, on-time pickups and comfortable rides, making your return journey hassle-free."
    },
    {
      "name": "Andheri to Pune Cab Innova Crysta",
      "description": "Hire an Innova Crysta from Andheri to Pune for a first-class ride experience. Best suited for families and business groups who value space, comfort, and premium service."
    },
    {
      "name": "Andheri to Pune Station Cab",
      "description": "Book a cab from Andheri to Pune Railway Station for a stress-free train connection. Skyline Cabs ensures timely drops with fixed fares and courteous drivers."
    },
    {
      "name": "Cab Service in Andheri",
      "description": "Skyline Cabs provides dependable cab service in Andheri for local travel, airport transfers, and long-distance trips to Pune and beyond. Choose from our fleet of sedans, SUVs, and luxury cars."
    },
    {
      "name": "Taxi Service in Andheri East & West",
      "description": "Whether you're in Andheri East or West, Skyline Cabs has you covered. Book taxis for outstation rides, airport transfers, and more with trained drivers and clean, AC-equipped vehicles."
    }
  ],
  "tableData": [
    ["Andheri to Pune Taxi", "Andheri to Pune Round Trip Cab"],
    ["Andheri to Pune Innova Crysta", "Taxi from Mumbai Andheri to Pune"],
    ["Andheri to Pune Ertiga Taxi Fare", "Andheri to Hinjewadi Cab Fare"],
    ["Andheri Airport to Pune Taxi Fare", "Mumbai Airport to Baner Cab Fare"],
    ["One Way Round Trip Cab from Mumbai", "Juhu to Pune Cab Service"],
    ["Cab Service in Juhu Mumbai", "Juhu to Pune One Way Cab Fare"],
    ["Sakinaka to Pune Cab Service", "Marol to Pune Cab"],
    ["Andheri to Pune Cab", "Pune to Andheri Cab"],
    ["Andheri to Pune Cab Innova Crysta", "Andheri to Pune Station Cab"],
    ["Cab Service in Andheri", "Taxi Service in Andheri East & West"]
  ],



  whychoose: [
    {
        "WhyChooseheading": "Reliable Andheri to Pune Cab Service",
        "WhyChoosedescription": "Skyline Cabs offers dependable cab services from Andheri to Pune, ensuring timely pickups and smooth rides for every traveler. Whether you’re heading for a business meeting, a family visit, or a weekend getaway, we make your intercity journey easy and stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
        "WhyChoosedescription": "Travel in complete comfort with our clean, air-conditioned vehicles. Choose from sedans, SUVs, or luxury cars—each maintained to the highest standards for a peaceful and pleasant ride from Andheri to Pune, with enough space for both passengers and luggage."
    },
    {
        "WhyChooseheading": "Experienced and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are professionally trained, background-verified, and well-acquainted with the Andheri to Pune route. They ensure a safe, smooth journey while maintaining a friendly and respectful attitude throughout the ride."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Get value for your money with our competitive fares. Skyline Cabs provides clear and upfront pricing—no hidden fees or last-minute surprises. You’ll always know exactly what you're paying for before the ride even begins."
    },
    {
        "WhyChooseheading": "24/7 Cab Availability from Andheri",
        "WhyChoosedescription": "No matter what time your travel plans are, Skyline Cabs is available 24/7. Whether you need an early morning departure or a late-night pickup from Andheri, we’re always ready to drive you to Pune with prompt service."
    },
    {
        "WhyChooseheading": "Multiple Cab Options to Suit Your Needs",
        "WhyChoosedescription": "Whether you're a solo traveler or part of a group, Skyline Cabs has the perfect vehicle for you. From fuel-efficient sedans to spacious SUVs and luxury models, you can choose a ride that fits your comfort and budget preferences."
    },
    {
        "WhyChooseheading": "Easy Booking with Real-Time Tracking",
        "WhyChoosedescription": "Book your Andheri to Pune cab quickly through our website or mobile app and receive instant confirmation. Track your ride in real-time, access driver details, and enjoy a seamless booking experience from start to finish."
    },
    {
        "WhyChooseheading": "Safe and Secure Intercity Rides",
        "WhyChoosedescription": "All our vehicles are GPS-enabled and sanitized before every trip. With strict safety protocols and verified drivers, Skyline Cabs guarantees a safe, secure, and reliable journey every time you travel from Andheri to Pune."
    }
]
















    }


    const faqData = [
        {
            id: 1,
            question: 'How do I book a cab from Andheri to Pune with Skyline Cabs?',
            answer:
                'You can book a cab online via our website or mobile app. Just select Andheri as your pickup location and Pune as your drop-off. Choose the vehicle that fits your needs and confirm your ride in minutes.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Andheri to Pune route?',
            answer:
                'Skyline Cabs offers a range of well-maintained vehicles like Sedans, SUVs, Ertiga, Innova Crysta, and luxury cars. Whether you’re traveling solo or with a group, we’ve got you covered.',
        },
        {
            id: 3,
            question: 'Is the fare from Andheri to Pune fixed?',
            answer:
                'Yes, we offer fixed pricing that includes tolls, driver charges, and taxes. You’ll see the total fare before booking, so there are no surprises.',
        },
        {
            id: 4,
            question: 'Can I book a round-trip cab from Andheri to Pune?',
            answer:
                'Absolutely! We provide both one-way and round-trip services. If you’re returning the same or a different day, just mention your return plan at the time of booking.',
        },
        {
            id: 5,
            question: 'How long does it take to travel from Andheri to Pune?',
            answer:
                'It typically takes around 3.5 to 4.5 hours depending on traffic. Our experienced drivers take the fastest and safest routes to get you to Pune on time.',
        },
        {
            id: 6,
            question: 'Is it possible to get picked up from Andheri East or West?',
            answer:
                'Yes, we serve both Andheri East and West. Just enter your exact pickup address while booking, and we’ll make sure the driver reaches you on time.',
        },
        {
            id: 7,
            question: 'Do you provide cabs from Andheri Railway Station to Pune?',
            answer:
                'Yes, we offer convenient pickups from Andheri Railway Station. You can schedule the pickup time as per your train’s arrival for a hassle-free transfer to Pune.',
        },
        {
            id: 8,
            question: 'Are your drivers professional and trained for intercity routes?',
            answer:
                'Definitely. Our drivers are experienced, verified, and well-trained for long-distance travel. They prioritize safety and comfort on every trip.',
        },
        {
            id: 9,
            question: 'Can I modify or cancel my Andheri to Pune booking?',
            answer:
                'Yes, Skyline Cabs offers flexible booking policies. You can easily modify or cancel your trip through our app, website, or by contacting customer support.',
        },
        {
            id: 10,
            question: 'Why choose Skyline Cabs for your Andheri to Pune journey?',
            answer:
                'With punctual pickups, sanitized vehicles, professional drivers, and transparent pricing, Skyline Cabs ensures your Andheri to Pune ride is smooth, comfortable, and completely stress-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Nikhil Rane",
            rating: 5,
            review: "Booked a cab from Andheri East to Pune for a business trip. The car was on time, clean, and the driver was professional. Loved how smooth the whole experience was. Great job Skyline Cabs!"
        },
        {
            name: "Miss. Prachi Kamat",
            rating: 4,
            review: "I traveled from Andheri West to Pune with Skyline. The cab was comfortable, and the driver was polite and well-versed with the route. Would’ve been perfect with onboard charging ports, but otherwise excellent!"
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Andheri to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/andheri-to-pune-cab.jpg",
  "description": "Book Andheri to Pune cab with Skyline Cabs for a comfortable, affordable, and on-time travel experience. Choose AC sedans or SUVs with verified drivers—available 24/7 for one-way or round-trip bookings.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7891"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1350",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/andheri-to-pune-cab"
  }
};


      
     


    return (
        <div>

<Helmet>
  <title>Andheri to Pune Cab | AC Sedan & SUV | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Andheri to Pune cab with Skyline Cabs for a comfortable, affordable, and on-time travel experience. Choose AC sedans or SUVs with verified drivers—available 24/7 for one-way or round-trip bookings." 
  />
  <meta 
    name="keywords" 
    content="Andheri to Pune Cab, Cab from Andheri to Pune, One-Way Taxi Andheri to Pune, Round Trip Cab Andheri to Pune, AC Sedan Cab Andheri to Pune, SUV Taxi Andheri to Pune, Online Cab Booking Andheri to Pune, Affordable Taxi Andheri to Pune, Skyline Cabs Andheri to Pune, 24/7 Andheri to Pune Cabs" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/33.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Andheritopunecab;